'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = EnterprisePlanCustomerCallout;

require('./enterprise-plan-customer-callout.scss');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Twitter = require('common/images/customers/logos/Twitter.svg');

var _Twitter2 = _interopRequireDefault(_Twitter);

var _Samsung_LogoSvg = require('common/images/customers/logos/Samsung_Logo.svg.png');

var _Samsung_LogoSvg2 = _interopRequireDefault(_Samsung_LogoSvg);

var _instacart = require('common/images/customers/logos/instacart.svg');

var _instacart2 = _interopRequireDefault(_instacart);

var _Lyft = require('common/images/customers/logos/Lyft.png');

var _Lyft2 = _interopRequireDefault(_Lyft);

var _intuit_95x = require('common/images/customers/logos/intuit_95x30.png');

var _intuit_95x2 = _interopRequireDefault(_intuit_95x);

var _openlegal_logo = require('common/images/customers/logos/openlegal_logo.svg');

var _openlegal_logo2 = _interopRequireDefault(_openlegal_logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function EnterprisePlanCustomerCallout() {

    var blurb = _react2['default'].createElement(
        'div',
        { className: 'blurb' },
        '45,000 companies trust us with their most important transactions.'
    );

    var allLogos = [_Twitter2['default'], _Samsung_LogoSvg2['default'], _instacart2['default'], _intuit_95x2['default'], _openlegal_logo2['default'], _Lyft2['default']];

    var logos = _react2['default'].createElement(
        'div',
        { className: 'logos' },
        allLogos.map(function (logosrc, idx) {
            return _react2['default'].createElement(
                'div',
                { key: 'logo-' + idx },
                _react2['default'].createElement('img', { src: logosrc })
            );
        })
    );

    return _react2['default'].createElement(
        'div',
        { className: 'm-enterprise-plan-customer-callout' },
        blurb,
        logos
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/choose-signup-plan/v2/enterprise-plan-customer-callout.jsx
 ** module id = 1177
 ** module chunks = 0
 **/